import { useCallback, useState } from 'react';

export const TURNSTILE_TOKEN_FIELD = 'turnstileToken';

const MISSING_TOKEN_MSG = 'Veuillez compléter la vérification anti-robot';

export const useTurnstile = () => {
  const [token, setToken] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [remountKey, setRemountKey] = useState(0);

  const handleSuccess = useCallback((value: string) => {
    setToken(value);
    setError(null);
  }, []);

  const handleError = useCallback(() => {
    setToken(null);
    setError('La vérification a échoué. Veuillez réessayer.');
  }, []);

  const handleExpire = useCallback(() => {
    setToken(null);
  }, []);

  const reset = useCallback(() => {
    setToken(null);
    setRemountKey(key => key + 1);
  }, []);

  const getTokenOrError = useCallback((): string | null => {
    if (!token) {
      setError(MISSING_TOKEN_MSG);
      return null;
    }
    setError(null);
    return token;
  }, [token]);

  return {
    token,
    error,
    reset,
    getTokenOrError,
    isVerified: !!token,
    widgetProps: {
      remountKey,
      onSuccess: handleSuccess,
      onError: handleError,
      onExpire: handleExpire,
    },
  };
};
